<template>
  <div id="messagelist">
    <SfSidebar
      :visible="isMessageSidebarOpen"
      :button="false"
      :title="$t('MyAccount_Message')"
      @close="toggleMessageSidebar"
      class="sidebar sf-sidebar--right"
    >
      <template #title>
        <div class="heading__wrapper">
          <SfHeading
            :level="3"
            :title="$t('MyAccount_Message')"
            class="sf-heading--left"
          />
          <SfButton
            class="heading__close-button sf-button--pure"
            aria-label="Wishlist sidebar close button"
            @click="toggleMessageSidebar"
          >
            <SfIcon icon="cross" size="14px" color="gray-primary" />
          </SfButton>
        </div>
      </template>
      <transition name="fade" mode="out-in">
        <div v-if="unReadList" class="my-wishlist" key="my-mesagelist">
          <div class="collected-product-list">
            <SfList class="ArticleList" ref="scrollContainer">
              <SfListItem v-for="item in unReadList" :key="item.msg_id">
                <div class="article">
                  <div class="article__title">{{ item.subject }}</div>
                  <div class="artilce__content">{{ item.content }}</div>
                  <div class="article__yuedu">
                    <div class="article__date">
                      {{
                        item.create_time
                          ? getCuurentDate(item.create_time)
                          : getCuurentDate(item.create_time)
                      }}
                    </div>
                    <div class="article__read">
                      <SfButton
                        class="sf-button--text"
                        @click="memberReadMsg(item.msg_id)"
                      >
                        {{ item.is_read != 1 ? $t('Message_Read') : '' }}
                      </SfButton>
                    </div>
                  </div>
                </div>
              </SfListItem>
              <paginate
                v-if="totalPageNo > 1"
                v-model="pageNo"
                :page-count="totalPageNo"
                :margin-pages="2"
                :page-range="5"
                :container-class="'sf-pagination products__pagination'"
                :activeClass="'current'"
                :page-link-class="'sf-pagination__item'"
                :prev-link-class="'sf-pagination__item'"
                :next-link-class="'sf-pagination__item'"
                :break-view-link-class="'break-view-link'"
                :no-li-surround="true"
                @input="changePageNo"
                hidePrevNext
              ></paginate>
            </SfList>
          </div>
          <div class="sidebar-bottom"></div>
        </div>
        <div v-else class="empty-wishlist" key="empty-wishlist">
          <div class="empty-wishlist__banner">
            <SfHeading
              :title="$t('Message_Empty')"
              :description="$t('Message_Empty_Title')"
              class="empty-wishlist__label"
            />
          </div>
        </div>
      </transition>
    </SfSidebar>
  </div>
</template>
<script>
import {
  SfSidebar,
  SfHeading,
  SfButton,
  SfIcon,
  SfProperty,
  SfList,
} from '@storefront-ui/vue';
import { ref, computed } from '@nuxtjs/composition-api';
import { userMessage, useUser } from '@bee-hole/coms';
import { useUiState } from '~/composables';
import Paginate from '~/components/Paginate.vue';
export default {
  name: 'Messagelist',
  components: {
    SfSidebar,
    SfButton,
    SfHeading,
    SfIcon,
    SfProperty,
    SfList,
    Paginate,
  },
  setup(props, context) {
    const { isMessageSidebarOpen, toggleMessageSidebar } =
      useUiState();
    const { unReadMsg, unResult, readMsg, readResult } = userMessage();
    const { isAuthenticated } = useUser();
    const getCuurentDate = context?.root?.$options?.getCuurentDate;
    const scrollContainer = ref(null);
    const pageSize = ref(10);
    const pageNo = ref(1);
    const totalPageNo = computed(
      () => Math.ceil(unResult?.value?.total_count / pageSize.value) || 1
    );
    const query = {
      limit: pageSize.value,
      page: pageNo.value,
    };
    // 请求未读站内信列表,并且返回未读站内信数量,和未读站内信列表
    if (isAuthenticated.value && context?.root?.$cookies?.get('token')) {
      unReadMsg(query);
    }
    // 读取站内信
    const memberReadMsg = async (msg_id) => {
      await readMsg({ msg_id: msg_id });
      if (readResult.value?.msg_id) {
        await unReadMsg(query);
      }
    };
    const changePageNo = (page_no) => {
      // console.error('page_no======>:', page_no);
      pageNo.value = page_no;
      unReadMsg({ ...query, page: page_no });
    };

    return {
      isAuthenticated,
      unReadList: computed(() => unResult.value?.list),
      isMessageSidebarOpen,
      toggleMessageSidebar,
      getCuurentDate,
      memberReadMsg,
      scrollContainer,
      pageSize,
      totalPageNo,
      pageNo,
      changePageNo,
    };
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  --sidebar-z-index: 3;
  --overlay-z-index: 3;
  --sidebar-top-padding: var(--spacer-lg) var(--spacer-base) 0
    var(--spacer-base);
  --sidebar-content-padding: var(--spacer-lg) var(--spacer-base);
}

.my-wishlist {
  flex: 1;
  display: flex;
  flex-direction: column;

  &__total-items {
    font: var(--font-weight--normal) var(--font-size--lg) / 1.6
      var(--font-family--secondary);
    color: var(--c-link);
    margin: 0;
  }

  &__total-price {
    --property-name-font-size: var(--font-size--xl);
    --price-font-size: var(--font-size--xl);
    margin: 0 0 var(--spacer-xl) 0;

    &-label {
      font: var(--font-weight--normal) var(--font-size--2xl) / 1.6
        var(--font-family--secondary);
      color: var(--c-link);
    }
  }
}

.empty-wishlist {
  display: flex;
  flex: 1;
  flex-direction: column;

  &__banner {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  &__label,
  &__description {
    text-align: center;
  }

  &__label {
    --heading-description-margin: 0 0 var(--spacer-xl) 0;
    --heading-title-margin: 0 0 var(--spacer-xl) 0;
    --heading-title-color: var(--c-primary);
    --heading-title-font-weight: var(--font-weight--semibold);

    @include for-desktop {
      --heading-title-font-size: var(--font-size--xl);
      --heading-title-margin: 0 0 var(--spacer-sm) 0;
    }
  }

  &__icon {
    --image-width: 16rem;
    margin: 0 0 var(--spacer-2xl) 7.5rem;
  }
}

.heading {
  &__wrapper {
    --heading-title-color: var(--c-link);
    --heading-title-font-weight: var(--font-weight--semibold);
    display: flex;
    justify-content: space-between;
  }
}

.sidebar-bottom {
  margin: auto 0 0 0;
}

.collected-product {
  margin: var(--spacer-base) 0;

  &__properties {
    margin: var(--spacer-sm) 0 0 0;
  }
}
.ArticleList {
  padding: 0 var(--spacer-lg);
  height: 61vh;
  overflow-y: auto;

  .article {
    border-bottom: 1px solid #f2f2f2;
    color: var(--c-dark);
    align-items: center;

    &__title {
      font-size: var(--h5-font-size);
      font-weight: var(--font-weight--bold);
      margin-bottom: var(--spacer-sm);
      margin-top: var(--spacer-sm);
    }

    &__content {
      font-size: var(--font-size--base);
      margin-bottom: var(--spacer-sm);
      margin-top: var(--spacer-sm);
      word-break: break-word;
    }

    &__yuedu {
      display: flex;
    }

    &__date {
      margin-bottom: var(--spacer-sm);
      margin-top: var(--spacer-sm);
      color: var(--_c-gray-secondary);
      flex: 1;
    }

    &__read {
      margin-bottom: var(--spacer-sm);
      margin-top: var(--spacer-sm);
    }
  }
}
</style>
<style lang="scss">
.image-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
  padding: 20px;
}

.sf-image--wrapper {
  display: block;
  margin: auto;
}

.empty-wishlist__icon {
  margin: 20px !important;
  width: 30%;

  .sf-image {
    width: 100%;
    display: flex;
    color: gray;
  }
}
</style>
